var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrabber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 6,
    viewBox: "0 0 36 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.497559,
    width: 36,
    height: 5.24869,
    rx: 2.5,
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrabber);
export default __webpack_public_path__ + "static/media/Grabber.579513ed9a68513ba082ad3a042df759.svg";
export { ForwardRef as ReactComponent };